/**
 * The record actions a section of the record offers (`SectionConfig.actions`, « Modifier » on « Convention »):
 * run from there, they are not offered a second time in the header.
 */

/** A tab as `detail-data` serves it: whatever its sections are, those of the « sections » tabs carry `actions`. */
type TabWithSections = { sections?: ReadonlyArray<object> | null };
type SectionWithActions = { actions?: Array<{ action_name: string }> | null };

export function sectionActionNames(tabs: TabWithSections[] | null | undefined): Set<string> {
    return new Set((tabs ?? []).flatMap(tab => (tab.sections ?? []).flatMap(section => ((section as SectionWithActions).actions ?? []).map(action => action.action_name))));
}

export function withoutSectionActions<T extends { action_name: string }>(actions: T[], tabs: TabWithSections[] | null | undefined): T[] {
    const offered = sectionActionNames(tabs);
    return offered.size ? actions.filter(action => !offered.has(action.action_name)) : actions;
}
